// Login.tsx — topograph's sign-in page.
//
// The shared OidcLoginPage decides the shape: it asks /api/oidc/config
// whether the backend can take a password, renders the form here when it can,
// and otherwise falls back to the /api/login redirect that was this app's
// only sign-in before. Either way the user ends up with a topograph_session
// cookie and lands back where they started.
//
// topograph's OIDC handler reads the post-login destination from `next`
// rather than `return_to`, and mounts the code flow at /api/login rather than
// /api/oidc/login, so both are passed explicitly.
import { useSearchParams } from 'react-router-dom';
import { OidcLoginPage } from 'common';
import { TopographNavbar } from '../components/TopographNavbar';

export function Login() {
    const [params] = useSearchParams();
    const next = params.get('next') || '/';

    return (
        <>
            <TopographNavbar />
            <OidcLoginPage
                title="Log In"
                returnTo={next}
                loginPath="/api/login"
                returnParam="next"
            />
        </>
    );
}

export default Login;
